import { Controller } from "@hotwired/stimulus"

// The inbox's sure matches: Show them lists each before Merge all runs them.
export default class extends Controller {
  static targets = ["list", "toggle"]

  toggle() {
    const open = this.listTarget.hidden
    this.listTarget.hidden = !open
    this.toggleTarget.textContent = open ? "Hide them" : "Show them"
    this.toggleTarget.setAttribute("aria-expanded", open)
  }
}
